import { ExtendedRouter, GlobalDispatcher } from "../../base/routing";
import { Dispatcher } from "./Dispatcher";
import { Query } from "./Query";
import { RoutesFactory } from "./RoutesFactory";

export class RouterFactory {
  static create(): ExtendedRouter {
    const dispatcher = new Dispatcher(r => new Query(r.query));
    const router = new ExtendedRouter((new RoutesFactory(dispatcher)).create());
    const globalDispatcher = new GlobalDispatcher(router, r => new Query(r.query));
    router.beforeEach((to, from, next) => globalDispatcher.dispatch(to, from, next));
    return router;
  }
}
